<template>
  <div>
    <div class="columns">
      <div class="column is-narrow" style="padding-right: 0;">
        <b-field>
          <b-input icon="magnify" v-model="search" placeholder="Cari..." style="font-size: inherit;"></b-input>
        </b-field>
      </div>

      <div class="column is-narrow">
        <div class="columns is-mobile">
          <div class="column is-narrow" style="padding-right: 0;">
            <div class="field cari-post">
              <div class="control">
                <div class="select">
                  <select v-model="sort">
                    <option value="">Pilih Urutan</option>
                    <option v-for="(s, key) in sort_options" :key="key" :value="s.value">{{ s.text }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <a class="button is-primary tooltip is-tooltip-right" data-tooltip="Terapkan" @click.prevent="clickHandler" :disabled="loading" :class="{'is-loading': loading}">
              <span class="icon"><i class="fas fa-filter"></i></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataProvider: {
      type: Object,
      required: true
    },
    clickHandler: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    search: {
      get() {
        const vm = this;
        const search = collect(this.dataProvider.criterion).where('criteria', vm.search_criteria).first();

        return !this.isEmpty(search) ? search.value : '';
      },
      set(val) {
        const vm = this;
        this.dataProvider['criterion'] = collect(this.dataProvider.criterion).map((c) => {
          if (c.criteria == vm.search_criteria) {
            c['value'] = val;
          }

          return c;
        }).toArray();
      }
    },
    sort: {
      get() {
        const vm = this;
        const sort = collect(this.dataProvider.sort).first();
        let option = null;

        if (!vm.isEmpty(sort)) {
          option = collect(this.sort_options).where('criteria', '==', sort.criteria).where('order', '==', sort.order).first();
        }

        return !this.isEmpty(option) ? option.value : '';
      },
      set(val) {
        const vm = this;
        let option = collect(this.sort_options).where('value', '==', val).first();

        if (!this.isEmpty(option)) {
          this.dataProvider['sort'] = [{
            criteria: option.criteria,
            order: option.order
          }]
        }
      }
    },
  },

  data() {
    return {
      open: false,
      search_criteria: 'name',
      sort_criteria: 'name',
      sort_options: [
        { criteria: 'name', order: 'asc', value: 'name__asc', text: 'A - Z' },
        { criteria: 'name', order: 'desc', value: 'name__desc', text: 'Z - A' },
        { criteria: 'created_at', order: 'desc', value: 'created_at__desc', text: 'Terbaru' },
        { criteria: 'created_at', order: 'asc', value: 'created_at__asc', text: 'Terlama' },
        { criteria: 'size', order: 'desc', value: 'size__desc', text: 'Ukuran Terbesar' },
        { criteria: 'size', order: 'asc', value: 'size__asc', text: 'Ukuran Terkecil' },
      ]
    }
  }
}
</script>
